import { SummaryDisplay } from '../../SummaryDisplay/SummaryDisplay';
import s from './ReviewRefundSummaryTask.module.css';
import { Flex } from '@repo/ui/Flex';

export const ReviewRefundSummaryTask = () => {
  return (
    <Flex className={s.reviewRefundSummaryTask}>
      <SummaryDisplay />
    </Flex>
  );
};
